import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AppSettings, Settings } from 'src/app/app.settings';
import {Slider} from "src/app/app.models";
import {SliderService} from "./sliders.service";
import {SliderDialogComponent} from "./slider-dialog/slider-dialog.component";

@Component({
  selector: 'app-sliders',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  providers: [ SliderService ],
})
export class SliderComponent implements OnInit {
  public sliders:Slider[] = [];
  public page: any;
  public count = 6;
  public settings:Settings;

  constructor(public appService: AppService,
              public dialog: MatDialog,
              public appSettings:AppSettings,
              public SliderService:SliderService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit(): void {
    this.getSliders();
  }

  public getSliders(){
    this.sliders = null;
    this.SliderService.getSlider().subscribe(slider =>{
      this.sliders = slider.results.map((res)=>{
        return{
          id: res.id,
          title: res.title,
          subtitle: res.subtitle,
          link: res.link,
          image: res.image,
          sortNumber: res.sortNumber
        }
      })
    })

    /* this.appService.getSliders().subscribe(data => {
       this.sliders = data; 
       this.sliders.shift();
     });*/
  }

  public onPageChanged(event){
    this.page = event;
    window.scrollTo(0,0);
  }
  public addSlider(slider:Slider){
    this.SliderService.addSlider(slider).subscribe(slider => this.getSliders());
  }
  public updateSlider(slider:Slider){
    this.SliderService.updateSlider(slider).subscribe(slider => this.getSliders());
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  public openSliderDialog(slider){
    const dialogRef = this.dialog.open(SliderDialogComponent, {
      data: {
        slider: slider,
        sliders: this.sliders
      },
      panelClass: ['theme-dialog'],
      autoFocus: false,
      direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });

    dialogRef.afterClosed().subscribe(slider => {
      if(slider){
        slider.id = slider.id == 0 ? null : slider.id
        const index: number = this.sliders.findIndex(x => x.id == slider.id);
        if(index !== -1){
          const image = slider.image[0]
          this.getBase64ImageFromUrl(image.preview).then(res => {
            this.SliderService.updateSlider(slider).subscribe(res=> {
              this.getSliders();
            })
          })
        }
        else{
          const image = slider.image[0]
          this.getBase64ImageFromUrl(image.preview).then(res => {
            this.SliderService.addSlider(slider).subscribe(res=> {
              this.getSliders();
            })
          })
        }
      }
    });
  }

  public remove(slider:any){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: {
        title: "Confirm Action",
        message: "Are you sure you want remove this slider?"
      }
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        const index: number = this.sliders.indexOf(slider);
        this.SliderService.deleteSlider(slider.id).subscribe(res=> {
          if (index !== -1) {
            this.sliders.splice(index, 1);
            setTimeout(()=>this.getSliders(),250);
          }
        })
      }
    });
  }

}
